import React, { useState } from 'react';

const emojiMap = {
    ':thumbs_up:': '👍',
    ':clap:': '👏',
    ':grinning_face:': '😀',
    ':face_with_open_mouth:': '😮',
    ':slightly_frowning_face:': '🙁',
    ':face_without_mouth:': '😶',
};

const createFlyingEmoji = (emoji, x, y) => {
    const element = document.createElement('div');
    element.textContent = emoji;
    element.className = 'flying-emoji';
    element.style.left = `${x}px`;
    element.style.top = `${y}px`;
    element.style.setProperty('--x-end', `${(Math.random() - 0.5) * 100}px`);
    document.body.appendChild(element);

    // Clean up emoji after animation
    setTimeout(() => {
        element.remove();
    }, 4500);
};

const ReactionsMenu = ({ handleEmojiClick }) => {
    const [isCooldown, setIsCooldown] = useState(false);

    const handleClick = (emoji, event) => {
        const rect = event.target.getBoundingClientRect();
        // Always show the flying emoji locally
        createFlyingEmoji(emoji, rect.left, rect.top);
        
        // Only send to others if not in cooldown
        if (!isCooldown) {
            handleEmojiClick(emoji);
            // Start cooldown
            setIsCooldown(true);
            setTimeout(() => {
                setIsCooldown(false);
            }, `${process.env.REACT_APP_REACTION_DISABLED_TIME}`);
        }
    };

    return (
        <div className="reactions-menu">
            <div className="reactions-row">
                <div aria-label="Thumbs Up" title="Thumbs Up" aria-pressed="false"
                    className="toolbox-button" role="button"
                    tabIndex="0" onClick={(e) => handleClick(emojiMap[':thumbs_up:'], e)}>
                    <div>
                        <div className="toolbox-icon"><span className="emoji increase-0">{emojiMap[':thumbs_up:']}</span></div>
                    </div>
                </div>
                <div aria-label="Clap" title="Clap" aria-pressed="false"
                    className="toolbox-button" role="button"
                    tabIndex="0" onClick={(e) => handleClick(emojiMap[':clap:'], e)}>
                    <div>
                        <div className="toolbox-icon"><span className="emoji increase-0">{emojiMap[':clap:']}</span></div>
                    </div>
                </div>
                <div aria-label="Laugh" title="Laugh" aria-pressed="false"
                    className="toolbox-button" role="button"
                    tabIndex="0" onClick={(e) => handleClick(emojiMap[':grinning_face:'], e)}>
                    <div>
                        <div className="toolbox-icon"><span className="emoji increase-0">{emojiMap[':grinning_face:']}</span></div>
                    </div>
                </div>
                <div aria-label="Surprised" title="Surprised" aria-pressed="false"
                    className="toolbox-button" role="button"
                    tabIndex="0" onClick={(e) => handleClick(emojiMap[':face_with_open_mouth:'], e)}>
                    <div>
                        <div className="toolbox-icon"><span className="emoji increase-0">{emojiMap[':face_with_open_mouth:']}</span></div>
                    </div>
                </div>
                <div aria-label="Boo" title="Boo" aria-pressed="false"
                    className="toolbox-button" role="button"
                    tabIndex="0" onClick={(e) => handleClick(emojiMap[':slightly_frowning_face:'], e)}>
                    <div>
                        <div className="toolbox-icon"><span className="emoji increase-0">{emojiMap[':slightly_frowning_face:']}</span></div>
                    </div>
                </div>
                <div aria-label="Silence" title="Silence" aria-pressed="false"
                    className="toolbox-button" role="button"
                    tabIndex="0" onClick={(e) => handleClick(emojiMap[':face_without_mouth:'], e)}>
                    <div>
                        <div className="toolbox-icon"><span className="emoji increase-0">{emojiMap[':face_without_mouth:']}</span></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Add a function that creates bubble animation for Reaction receivers
export const createReactionAnimation = (emoji) => {
    const reactionButton = document.querySelector('.context-menu-reactions');
    if (reactionButton) {
        const rect = reactionButton.getBoundingClientRect();
        const startX = rect.left + (rect.width / 2);
        const startY = rect.top;
        createFlyingEmoji(emoji, startX, startY);
    }
};

export { createFlyingEmoji, emojiMap };

export default ReactionsMenu;